import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  paper: {
    display: 'flex',
    flexGrow: 1,
  },
});
